import * as React from 'react';
import * as dayjs from 'dayjs';
import Calendar from 'react-calendar';
import DayOffCalendarItem from './DayOffsCalendarItem';
var styles = {
    container: {
        minHeight: '100px'
    }
};
var itemsByDay = function (items, date) { return items.filter(function (i) {
    var a = dayjs(i.date);
    var b = dayjs(date);
    return a.isSame(b, 'year') && a.isSame(b, 'month') && a.isSame(b, 'day');
}); };
var DayOffCalendarTile = function (items) { return function (_a) {
    var date = _a.date, view = _a.view;
    if (view !== 'month') {
        return null;
    }
    var currentItems = itemsByDay(items, date)
        .map(function (i) { return React.createElement(DayOffCalendarItem, { key: i.id, item: i }); });
    return (React.createElement("div", { style: styles.container }, currentItems));
}; };
export default function DayOffsCalendar(_a) {
    var items = _a.items, onDateChange = _a.onDateChange;
    return (React.createElement(Calendar, { locale: "hu-HU", className: "dayoffs-calendar no-select", tileContent: DayOffCalendarTile(items), onActiveDateChange: onDateChange, maxDetail: "month", minDetail: "month" }));
}



//////////////////
// WEBPACK FOOTER
// ./src/pages/dayoffs/DayOffsCalendar.tsx
// module id = 791
// module chunks = 0